import { type Styles, css } from "../../../../styled-system/css";

export type CellProps = {
  label: string;
  value: string;
  lastChild?: boolean;
  styles?: Styles;
};

export function Cell({ label, value, lastChild, styles }: CellProps) {
  return (
    <div
      className={css({
        display: "flex",
        gap: "8px",
        borderBottom: lastChild ? "none" : "1px solid",
        borderColor: "border.secondary",
        py: "16px",
        ...styles,
      })}
    >
      <h4
        className={css({
          color: "text.primary",
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
        })}
      >
        {label}
      </h4>
      <p
        className={css({
          color: "text.secondary",
          flexGrow: 1,
          textAlign: "right",
          wordBreak: "break-word",
        })}
      >
        {value}
      </p>
    </div>
  );
}
